import { render, staticRenderFns } from "./editEmployerClient.vue?vue&type=template&id=06501f04&scoped=true"
import script from "./editEmployerClient.vue?vue&type=script&lang=js"
export * from "./editEmployerClient.vue?vue&type=script&lang=js"
import style0 from "./editEmployerClient.vue?vue&type=style&index=0&id=06501f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06501f04",
  null
  
)

export default component.exports